import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { FloatingActions } from '@/components/generals/floating-actions'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='focus-ring sr-only z-[70] rounded-full bg-white px-4 py-2 text-sm font-semibold text-ink focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
            >
                Skip to content
            </a>

            <Header />

            <main id='main-content' className='flex-1'>
                {children}
            </main>

            <Footer />
            <FloatingActions />
        </div>
    )
}
